<elder-single-pane-wrapper>
  <div class="gap-lg layout-row gap-lg mat-typography p-sm scrollable">
    <!-- Welcome Card -->
    <mat-card appearance="outlined" class="flex border-none">
      <mat-card-header>
        <div mat-card-avatar class="background-primary place-center-center">
          <mat-icon>timeline</mat-icon>
        </div>
        <mat-card-title>{{ 'main.title' | translate }}</mat-card-title>
        <mat-card-subtitle>{{ 'dashboard.welcomeCard.subtitle' | translate }}</mat-card-subtitle>
      </mat-card-header>

      @if (principal$ | async; as principal) {
        <mat-card-content>
          <h2>{{ 'dashboard.welcomeCard.greeting' | translate }} {{ principal.name }}!</h2>
          <p>{{ 'dashboard.welcomeCard.msg' | translate }}</p>
        </mat-card-content>
      }

      <div class="place-end-center">
        <button mat-button (click)="openNav($event)">{{ 'actions.openNav' | translate }}</button>
      </div>
    </mat-card>
  </div>
</elder-single-pane-wrapper>
